<header class="header">
  <div class="header-container">
    <!-- Logo -->
    <div class="logo-section">
      <img src="assets/icons/logo_with_name.png" alt="Showlab Logo" class="logo" />
    </div>
    <!-- Navigation Links -->
    <!-- <nav class="navigation">
      <a href="#" class="nav-link">to showcase</a>
      <a href="#" class="nav-link">to collaborate</a>
      <a href="#" class="nav-link">our purpose</a>
    </nav> -->
    <!-- Auth Buttons -->
    <div class="auth-buttons">
      <button class="btn-login" [class.selected]="selectedButton === 'login'" (click)="onLogin()">
        log in
      </button>
      <button class="btn-signup" [class.selected]="selectedButton === 'signup'" (click)="navigateToForm1()">
        get started
      </button>
    </div>
  </div>
</header>